import React, {Fragment} from 'react';
import * as R from 'ramda/src/index';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Specification from 'cms/faqs/Article/Policy/Specification';

const OpenPolicy = ({companyName, policies, translations}) => {
  const {
    companyOpenDatedTicketPolicy, openPolicyOtherDates, openPolicyDateRange,
    openPolicyRefundCancellation
  } = translations;

  const atLeastNotLowSeason = policies.some(({isLowSeason}) => !isLowSeason);

  return (
    <Fragment>
      <div className="font-bold">{companyOpenDatedTicketPolicy.replace('{company}', companyName)}</div>
      {
        policies.map(({isLowSeason, specifications, dates, openTicketExpiryPolicy, notes}, index) => (
          <div key={index} className="mb-2">
            {
              atLeastNotLowSeason &&
                <div className="my-2">
                  {
                    isLowSeason ? openPolicyOtherDates :
                      openPolicyDateRange.replace('{date}', dates.join(', '))
                  }
                  {notes && <Fragment><br/>{notes}</Fragment>}
                </div>
            }
            <ul>
              {
                specifications.map(({hoursPrior, destinations, notes, reroute, isRefundable, refundAmount}, index) =>
                  <Specification
                    key={index}
                    hoursPrior={hoursPrior}
                    destinations={destinations}
                    notes={notes}
                    reroute={reroute}
                    isRefundable={isRefundable}
                    refundAmount={refundAmount}
                    openTicketExpiryPolicy={openTicketExpiryPolicy}
                    translations={translations}
                  />
                )
              }
              {
                specifications.map(({hoursPrior, locationGroups, notes, reroute, isRefundable, refundAmount}, index) =>
                  locationGroups.length > 0 && <Specification
                    key={index}
                    hoursPrior={hoursPrior}
                    destinations={locationGroups}
                    notes={notes}
                    reroute={reroute}
                    isRefundable={isRefundable}
                    refundAmount={refundAmount}
                    openTicketExpiryPolicy={openTicketExpiryPolicy}
                    translations={translations}
                  />
                )
              }
            </ul>
            {
              R.pathOr(false, ['0', 'isRefundable'], specifications) &&
                <p>{openPolicyRefundCancellation.replace('{refund}', `${specifications[0].refundAmount}%`)}</p>
            }
          </div>
        ))
      }
    </Fragment>
  );
};

OpenPolicy.propTypes = {
  companyName: PropTypes.string.isRequired,
  policies: PropTypes.object.isRequired,
  translations: PropTypes.shape({
    companyOpenDatedTicketPolicy: PropTypes.string.isRequired, 
    openPolicyOtherDates: PropTypes.string.isRequired,
    openPolicyDateRange: PropTypes.string.isRequired,
    openPolicyRefundCancellation: PropTypes.string.isRequired
  }).isRequired
};

export default observer(OpenPolicy);
